<figure class="tw-preview-first">
    <core-preview-page *ngIf="exist && fileIdFound > 0" [fileId]="fileIdFound" [format]="format" [page]="1"></core-preview-page>
    <core-preview-waiting *ngIf="pending" [format]="format"></core-preview-waiting>
    <core-preview-not-found *ngIf="!exist && fileIdFound == 0" [file]="files[0].name"></core-preview-not-found>
</figure>
